import ContentAddCircle from 'material-ui/svg-icons/content/add-circle';
import { func, number, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { colors } from 'styles/provider';

import ContentColumns from '../../components/ContentColumns';
import ControlSteps from '../../components/ControlSteps';
import DoneItemsList from '../../components/DoneItemsList';
import TextAreaWithSuggestions from '../../components/TextAreaWithSuggestions';

const addCircleStyle = {
  width: '3rem',
  height: '3rem',
  color: colors.clrSecondary,
  display: 'block',
};
const iconAreaStyle = {
  padding: '0 0.5rem 0 0',
};

// Placeholders, change these names to something more descriptive when they are defined somewhere
const suggestions = [
  'mean1cog',
  'mean2cog',
  'mean3cog',
  'mean4cog',
  'mean5cog',
  'mean6cog',
  'mean7cog',
  'mean8cog',
  'mean9cog',
  'mean10cog',
  'mean11cog',
];
const suggestionsLocale = 'onlineRehabilitation.opts.';

const View8 = ({ viewIndex }, { fm, fmString, formValues, onChange }) => {
  const getValue = (name, index) => path(['rehab5', name, index], formValues) || '';

  const onChangePlans = (name, index) => event => {
    const allValues = path(['rehab5', name], formValues) || ['', '', ''];
    const eventValue = path(['currentTarget', 'value'], event);
    // Copy array so that changes dont roll backwards
    const allValuesMapped = allValues.map(a => a);
    allValuesMapped[index] = eventValue;
    onChange({ [name]: allValuesMapped });
  };

  const addNewPlan = () => {
    const allValues = path(['rehab5', 'plannedChangesToManageCognitiveProblems'], formValues);
    const newIndex = Array.isArray(allValues) ? allValues.length : 3;
    onChangePlans('plannedChangesToManageCognitiveProblems', newIndex)({ currentTarget: { value: '' } });
  };

  const doneItems = [
    { locale: 'onlineRehabilitation.rehab5.cognitiveProblemsGiven', canUpdate: false },
    { locale: 'onlineRehabilitation.rehab5.cognitiveProblemsGoals', canUpdate: false },
  ];

  const nearFutureTarget = path(['rehab5', 'nearFutureTarget'], formValues);

  const plans = path(['rehab5', 'plannedChangesToManageCognitiveProblems'], formValues) || [];

  const sessionFinished = !!path(['rehab5', 'finished'], formValues);

  return (
    <ContentColumns
      firstColumn={
        <div>
          <h2>{fm('onlineRehabilitation.rehab5.8.header')}</h2>
          <br />
          <ControlSteps steps={{ nearFutureTarget: nearFutureTarget }} cognition fm={fm} />
          <br />
          <div>{fm('onlineRehabilitation.rehab5.8.text')}</div>

          <TextAreaWithSuggestions
            header={fmString('onlineRehabilitation.rehab5.8.changeHeader', { n: 1 })}
            onChange={onChangePlans('plannedChangesToManageCognitiveProblems', 0)}
            value={getValue('plannedChangesToManageCognitiveProblems', 0)}
            name={'plannedChangesToManageCognitiveProblems'}
            textPlaceholder={fmString('onlineRehabilitation.rehab5.8.changePlaceholder', { n: 1 })}
            suggestions={suggestions}
            suggestionsLocale={suggestionsLocale}
            disabled={sessionFinished}
          />
          <TextAreaWithSuggestions
            header={fmString('onlineRehabilitation.rehab5.8.changeHeader', { n: 2 })}
            onChange={onChangePlans('plannedChangesToManageCognitiveProblems', 1)}
            value={getValue('plannedChangesToManageCognitiveProblems', 1)}
            name={'plannedChangesToManageCognitiveProblems'}
            textPlaceholder={fmString('onlineRehabilitation.rehab5.8.changePlaceholder', { n: 2 })}
            suggestions={suggestions}
            suggestionsLocale={suggestionsLocale}
            disabled={sessionFinished}
          />
          <TextAreaWithSuggestions
            header={fmString('onlineRehabilitation.rehab5.8.changeHeader', { n: 3 })}
            onChange={onChangePlans('plannedChangesToManageCognitiveProblems', 2)}
            value={getValue('plannedChangesToManageCognitiveProblems', 2)}
            name={'plannedChangesToManageCognitiveProblems'}
            textPlaceholder={fmString('onlineRehabilitation.rehab5.8.changePlaceholder', { n: 3 })}
            suggestions={suggestions}
            suggestionsLocale={suggestionsLocale}
            disabled={sessionFinished}
          />
          {plans.map((_, i) => {
            // Only map those added using the button
            if (i < 3) return null;
            return (
              <TextAreaWithSuggestions
                key={i}
                header={fmString('onlineRehabilitation.rehab5.8.changeHeader', { n: i + 1 })}
                onChange={onChangePlans('plannedChangesToManageCognitiveProblems', i)}
                value={getValue('plannedChangesToManageCognitiveProblems', i)}
                name={'plannedChangesToManageCognitiveProblems'}
                textPlaceholder={fmString('onlineRehabilitation.rehab5.8.changePlaceholder', { n: i + 1 })}
                suggestions={suggestions}
                suggestionsLocale={suggestionsLocale}
                disabled={sessionFinished}
              />
            );
          })}
          <br />
          {!sessionFinished && (
            <React.Fragment>
              <button
                style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', border: 0, backgroundColor: '#fff' }}
                onClick={addNewPlan}
              >
                <div style={iconAreaStyle}>
                  <ContentAddCircle style={addCircleStyle} />
                </div>
                <h3>{fm('onlineRehabilitation.addChange')}</h3>
              </button>
              <br />
            </React.Fragment>
          )}
          <div>{fm('onlineRehabilitation.rehab5.8.send')}</div>
        </div>
      }
      secondColumn={
        <div>
          <DoneItemsList itemList={doneItems} />
        </div>
      }
    />
  );
};

View8.contextTypes = {
  fm: func,
  fmString: func,
  formValues: object,
  onChange: func,
};
View8.propTypes = {
  viewIndex: number,
};

export default View8;
